module.exports = __webpack_public_path__ + "static/media/timeline-3.646ca54f.png";